import store from "../../store";
import Cookies from "js-cookie";

export const getCurrentUser = () =>{
  return {...JSON.parse(localStorage.getItem("userDetails") || "{}"), ...JSON.parse(Cookies.get("userDetails") || "{}")};
}
export const getAuthToken = () => {
                const storedData = Cookies.get("userDetails") || "{}";
              const token = JSON.parse(storedData)?.fetchAPI;
  return token || "";
};
export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken") || "";
};

export const getToken = () => {
  const token = getAuthToken();
  return token || "";
};

export const handleLogin = (details: any = {}, response?: any, fetchMSGraphAPI?: any) => {
  const userDetails = {...details};
  delete userDetails.accessToken;
  delete userDetails.emailId;
  Cookies.set("userDetails", JSON.stringify({emailId: details?.emailId, fetchAPI: details.accessToken, fetchMSGraphAPI: fetchMSGraphAPI}), { secure: true, expires: 7 });
  localStorage.setItem("userDetails", JSON.stringify({...userDetails}));
  store.dispatch({
    type: "SESSION:SET_IS_LOGGED_IN",
    payload: {
      value: true,
      userDetails: response,
    },
  })
  globalThis.location.reload(); ;

};
